import { PopupRedirectComponent } from './popup-redirect.component';

export const PopupRedirectModule = angular
  .module('fMobile.components.popup-redirect', [])
  .component('sfPopupRedirect', PopupRedirectComponent).name;
